import { Environment } from './environment';

export const environment: Environment = {
  production: true,
  serverUrl: 'wss://hub.winsignage.com:443',
  assetDownloadBaseUrl: 'https://hub.winsignage.com/api',
  defaultClientId: 'CBXMWZJ4',
  defaultClientSecret: '045XNQL3',
  enableDebugMode: true,
  logLevel: 'debug',
  reconnectInterval: 5000, // 5 seconds
  maxReconnectAttempts: 10,

  prefetchConcurrency: 3,
  prefetchLookahead: 1,
  maxCacheBytes: 512 * 1024 * 1024, // 512 MB
  assetFetchTimeoutMs: 60000,
  mediaStartTimeoutMs: 20000,
};
